// Display name of a store's connected sales channel, for user-facing copy.
// store_type IS the channel platform (shopify / woocommerce); ERP is a separate
// connector, so this is a faithful label. Brand names are proper nouns (not
// translated); the generic fallback (manual / unknown store) is translated.
export function channelName(storeType, t) {
  if (storeType === 'shopify') return 'Shopify';
  if (storeType === 'woocommerce') return 'WooCommerce';
  return t('dataHealth.genericChannel');
}
